import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Download from './components/Download';
import './App.css';
import { initIam } from './hook/iam';
import { getQueryString } from './utils/url';

// 路由配置类型定义
interface RouteConfig {
  path: string;
  element: React.ReactElement;
  title?: string; // 可选的页面标题，便于后期扩展
}

// 路由配置
const routes: RouteConfig[] = [
  {
    path: '/',
    element: <Download />,
    title: '智能助手下载'
  },
  // {
  //   path: '/download',
  //   element: <Download />,
  //   title: '智能助手下载'
  // }
]

// 页面标题管理组件
const PageTitleManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // 根据当前路径找到对应的路由配置
    const currentRoute = routes.find(route => route.path === location.pathname);
    
    // 设置页面标题
    if (currentRoute?.title) {
      document.title = currentRoute.title;
    } else {
      document.title = '智能助手下载'; // 使用环境配置中的应用名称
    }
  }, [location.pathname]);

  return null; // 这个组件不渲染任何内容
};

const AppContent: React.FC = () => {
  return (
    <div className="App">
      <PageTitleManager />
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          />
        ))}
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    if(getQueryString('usercode')){
      initIam();
    }
  }, []);
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App; 